import React from 'react'
import { FaUsers, FaMicrophone, FaChartBar, FaList, FaTrophy, FaRegPlayCircle, FaBorderAll } from 'react-icons/fa';
import useTranslation from '../useTranslation';
import './TabSelector.scss'

export default function TabSelector({ 
    gameType, 
    selectedTab, 
    displayInnings, 
    innings1battingteam, 
    innings2battingteam, 
    innings3battingteam, 
    innings4battingteam, 
    frameBackgroundColor, 
    frameForegroundColor,
    parlay,
    setSelectedInnings,
    layout,
    handleScore,
    handleScoregrid,
    handleCommentary,
    handleStats,
    handleScorecards,
    handleCharts,
    handleCartoons,
    handleMatch
}) {

    const ScoreLabel = useTranslation('Score')
    const CommentaryLabel = useTranslation('Commentary')
    const ScorecardLabel = useTranslation('Scorecard')
    const ChartsLabel = useTranslation('Charts')
    const CartoonsLabel = useTranslation('Cartoons')
    const MatchLabel = useTranslation('Match')
    const StatsLabel = useTranslation('Stats')
    const ScoregridLabel = useTranslation('Scoregrid') || 'Scoregrid'

    if (parlay) { 
        return (
            <div className="selectors">
                <div className="selector" style={{ borderColor: frameBackgroundColor }}>
                    { gameType === 'QUANTUM' ? (
                        <button onClick={ handleScoregrid } className={ selectedTab === 'scoregrid' ? 'active' : '' } 
                            style={{ backgroundColor: selectedTab === 'scoregrid' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'scoregrid' ? frameBackgroundColor : frameForegroundColor }}>
                            <FaBorderAll size={20}/>
                            <span className="selector-text">{ScoregridLabel}</span>
                        </button>
                    ) : (
                        <button onClick={ handleCommentary } className={ selectedTab === 'commentary' ? 'active' : '' } 
                            style={{ backgroundColor: selectedTab === 'commentary' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'commentary' ? frameBackgroundColor : frameForegroundColor }}>
                            <FaMicrophone size={20}/>
                            <span className="selector-text">{CommentaryLabel}</span>
                        </button>
                    )} 
                    <button onClick={ handleCartoons } className={ selectedTab === 'cartoons' ? 'active' : '' } 
                        style={{ backgroundColor: selectedTab === 'cartoons' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'cartoons' ? frameBackgroundColor : frameForegroundColor }}>
                        <FaRegPlayCircle size={20}/>
                        <span className="selector-text">{CartoonsLabel}</span>
                    </button>
                    { layout === 'single' && (
                        <button onClick={ handleScore } className={ selectedTab === 'score' ? 'active' : '' } 
                            style={{ backgroundColor: selectedTab === 'score' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'score' ? frameBackgroundColor : frameForegroundColor }}>
                            <FaTrophy size={20}/>
                            <span className="selector-text">{ScoreLabel}</span>
                        </button>
                    )}
                    { (gameType !== 'KABD' && gameType !== 'VRKBD') && 
                        <button onClick={ handleCharts } className={ selectedTab === 'charts' ? 'active' : '' } 
                            style={{ backgroundColor: selectedTab === 'charts' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'charts' ? frameBackgroundColor : frameForegroundColor }}>
                            <FaChartBar size={20}/>
                            <span className="selector-text">{ChartsLabel}</span>
                        </button>     
                    }
                    { gameType !== 'VRKBD' && 
                        <button onClick={ handleMatch } className={ selectedTab === 'match' ? 'active' : '' } 
                            style={{ backgroundColor: selectedTab === 'match' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'match' ? frameBackgroundColor : frameForegroundColor }}>
                            <FaUsers size={20}/>
                            <span className="selector-text">{MatchLabel}</span>
                        </button>
                    }
                </div>

                { gameType !== 'KABD' && gameType !== 'VRKBD' && selectedTab !== 'score' && selectedTab !== 'match' && selectedTab !== 'charts' && selectedTab !== 'cartoons' &&
                    <div className="team-selector" style={{ borderColor: frameBackgroundColor }}>
                        { innings1battingteam && 
                            <button onClick={ () => setSelectedInnings(1) } className={ displayInnings === 1 ? 'active' : '' } 
                                style={{ backgroundColor: displayInnings === 1 ? frameForegroundColor : frameBackgroundColor, color: displayInnings === 1 ? frameBackgroundColor : frameForegroundColor }}>{innings1battingteam + ' (1)' || '-'}</button> }
                        { innings2battingteam && 
                            <button onClick={ () => setSelectedInnings(2) } className={ displayInnings === 2 ? 'active' : '' } 
                                style={{ backgroundColor: displayInnings === 2 ? frameForegroundColor : frameBackgroundColor, color: displayInnings === 2 ? frameBackgroundColor : frameForegroundColor }}>{innings2battingteam + ' (2)' || '-'}</button> }
                        { innings3battingteam && 
                            <button onClick={ () => setSelectedInnings(3) } className={ displayInnings === 3 ? 'active' : '' } 
                                style={{ backgroundColor: displayInnings === 3 ? frameForegroundColor : frameBackgroundColor, color: displayInnings === 3 ? frameBackgroundColor : frameForegroundColor }}>{innings3battingteam + ' (3)' || '-'}</button> }
                        { innings4battingteam && 
                            <button onClick={ () => setSelectedInnings(4) } className={ displayInnings === 4 ? 'active' : '' } 
                                style={{ backgroundColor: displayInnings === 4 ? frameForegroundColor : frameBackgroundColor, color: displayInnings === 4 ? frameBackgroundColor : frameForegroundColor }}>{innings4battingteam + ' (4)' || '-'}</button> }
                    </div>
                }
            </div>
        )
    }

    return (
        <div className="selectors">
            <div className="selector" style={{ borderColor: frameBackgroundColor }}>
                { layout === 'single' && (
                    <button onClick={ handleScore } className={ selectedTab === 'score' ? 'active' : '' } 
                        style={{ backgroundColor: selectedTab === 'score' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'score' ? frameBackgroundColor : frameForegroundColor }}>
                        <FaTrophy size={20}/>
                        <span className="selector-text">{ScoreLabel}</span>
                    </button>
                )}
                { gameType === 'QUANTUM' ? (
                    <button onClick={ handleScoregrid } className={ selectedTab === 'scoregrid' ? 'active' : '' } 
                        style={{ backgroundColor: selectedTab === 'scoregrid' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'scoregrid' ? frameBackgroundColor : frameForegroundColor }}>
                        <FaBorderAll size={20}/>
                        <span className="selector-text">{ScoregridLabel}</span>
                    </button>
                ) : (
                    <button onClick={ handleCommentary } className={ selectedTab === 'commentary' ? 'active' : '' } 
                        style={{ backgroundColor: selectedTab === 'commentary' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'commentary' ? frameBackgroundColor : frameForegroundColor }}>
                        <FaMicrophone size={20}/>
                        <span className="selector-text">{CommentaryLabel}</span>
                    </button>
                )} 
                { (gameType === 'KABD' || gameType === 'VRKBD') && (
                    <button onClick={ handleStats } className={ selectedTab === 'stats' ? 'active' : '' } 
                        style={{ backgroundColor: selectedTab === 'stats' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'stats' ? frameBackgroundColor : frameForegroundColor }}>
                        <FaList size={20}/>
                        <span className="selector-text">{StatsLabel}</span>
                    </button>
                )}
                { (gameType !== 'KABD' && gameType !== 'VRKBD') && 
                    <>
                        <button onClick={ handleScorecards } className={ selectedTab === 'scorecards' ? 'active' : '' } 
                            style={{ backgroundColor: selectedTab === 'scorecards' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'scorecards' ? frameBackgroundColor : frameForegroundColor }}>
                            <FaList size={20}/>
                            <span className="selector-text">{ScorecardLabel}</span>
                        </button>
                        <button onClick={ handleCharts } className={ selectedTab === 'charts' ? 'active' : '' } 
                            style={{ backgroundColor: selectedTab === 'charts' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'charts' ? frameBackgroundColor : frameForegroundColor }}>
                            <FaChartBar size={20}/>
                            <span className="selector-text">{ChartsLabel}</span>
                        </button>
                    </>
                }
                <button onClick={ handleCartoons } className={ selectedTab === 'cartoons' ? 'active' : '' } 
                    style={{ backgroundColor: selectedTab === 'cartoons' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'cartoons' ? frameBackgroundColor : frameForegroundColor }}>
                    <FaRegPlayCircle size={20}/>
                    <span className="selector-text">{CartoonsLabel}</span>
                </button>
                { gameType !== 'VRKBD' && 
                    <button onClick={ handleMatch } className={ selectedTab === 'match' ? 'active' : '' } 
                        style={{ backgroundColor: selectedTab === 'match' ? frameForegroundColor : frameBackgroundColor, color: selectedTab === 'match' ? frameBackgroundColor : frameForegroundColor }}>
                        <FaUsers size={20}/>
                        <span className="selector-text">{MatchLabel}</span>
                    </button>
                }
            </div>

            { gameType !== 'KABD' && gameType !== 'VRKBD' && selectedTab !== 'score' && selectedTab !== 'match' && selectedTab !== 'charts' && selectedTab !== 'cartoons' &&
                <div className="team-selector" style={{ borderColor: frameBackgroundColor }}>
                    { innings1battingteam && 
                        <button onClick={ () => setSelectedInnings(1) } className={ displayInnings === 1 ? 'active' : '' } 
                            style={{ backgroundColor: displayInnings === 1 ? frameForegroundColor : frameBackgroundColor, color: displayInnings === 1 ? frameBackgroundColor : frameForegroundColor }}>{innings1battingteam + ' (1)' || '-'}</button> }
                    { innings2battingteam && 
                        <button onClick={ () => setSelectedInnings(2) } className={ displayInnings === 2 ? 'active' : '' } 
                            style={{ backgroundColor: displayInnings === 2 ? frameForegroundColor : frameBackgroundColor, color: displayInnings === 2 ? frameBackgroundColor : frameForegroundColor }}>{innings2battingteam + ' (2)' || '-'}</button> }
                    { innings3battingteam && 
                        <button onClick={ () => setSelectedInnings(3) } className={ displayInnings === 3 ? 'active' : '' } 
                            style={{ backgroundColor: displayInnings === 3 ? frameForegroundColor : frameBackgroundColor, color: displayInnings === 3 ? frameBackgroundColor : frameForegroundColor }}>{innings3battingteam + ' (3)' || '-'}</button> }
                    { innings4battingteam && 
                        <button onClick={ () => setSelectedInnings(4) } className={ displayInnings === 4 ? 'active' : '' } 
                            style={{ backgroundColor: displayInnings === 4 ? frameForegroundColor : frameBackgroundColor, color: displayInnings === 4 ? frameBackgroundColor : frameForegroundColor }}>{innings4battingteam + ' (4)' || '-'}</button> }
                </div>
            }
        </div>
    )
}
